import { Default, Detail, List,  Create } from "./views";



const Module = {
    name: "costcenters",
    defaultRoutePath: "/legalentities/costcenter",
    menuItemScope: "legalentities",
    menuItemName: "costcenters",

    routes: [
        {
            path: "/legalentities/costcenter",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
